import { CommonRequestParams } from "api/api.types"
import { snakelize, camelize } from "../../../helpers/object"
import { GetBrandResponse } from "./brand.types"

export default ($axios: any) => ({
  /**
   * 브랜드 조회 API
   */
  async getBrand(data?: CommonRequestParams): Promise<GetBrandResponse> {
    return camelize(await $axios.get(`/brand/${data.brandToken}`, snakelize({ params: data })))
  },

  /**
   * 브랜드 조회 API
   */
  async show(data?: any) {
    return camelize(await $axios.get(`/brand/${data.brandToken}`, snakelize({ params: data })))
  },

  /**
   * 브랜드 수정 API
   */
  async update(data?: any) {
    return camelize(await $axios.patch(`/brand/${data.brandToken}`, snakelize(data)))
  },

  /**
   * 이미지 업로드 API
   */
  async uploadLogo(data?: any) {
    const formData = new FormData()
    formData.append("image", data.image)
    formData.append("brand_token", data.brandToken)

    return camelize(await $axios.post("/brand/logo/upload", formData))
  },

  /**
   * 포스팅 갯수 조회 API
   */
  async getPostingStatus(data?: any) {
    const result = camelize(await $axios.get(`/brand/posting-status`, snakelize({ params: data })))
    return result
  },

  async rules(data?: any) {
    return camelize(await $axios.get(`/brand/${data.brandId}/rules`, snakelize({ params: data })))
  },

  // for dev
  async rulesOld(data?: any) {
    return camelize(await $axios.get(`/brand/${data.brandId}/rules/old`, snakelize({ params: data })))
  },

  /**
   * 브랜드가 모집 중인 캠페인에 특정 인플루언서가 지원할 수 있도록 도움 요청
   * Request help for specific influencer to apply to brand's recruiting campaign
   */
  async storeBrandRequestRecruitingCampaignApplication(data?: any) {
    return camelize(await $axios.post(`/brand/request/recruiting-campaign-application`, snakelize(data)))
  }
})
